import { render, staticRenderFns } from "./App.vue?vue&type=template&id=bb340ffc&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=bb340ffc&prod&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=bb340ffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb340ffc",
  null
  
)

export default component.exports